import type {
  AgentInboxMarkReadInput,
  AgentInboxMarkAllReadInput,
  AgentInboxListMessagesParams,
} from '../api'
import { api } from '../api'

const agentInboxListMessages = async (data: AgentInboxListMessagesParams) => {
  return await api.v1.agentInboxListMessages(data)
}

const agentInboxMarkAsRead = async (data: AgentInboxMarkReadInput) => {
  return await api.v1.agentInboxMarkAsRead(data)
}

const agentInboxMarkAllAsRead = async (data: AgentInboxMarkAllReadInput) => {
  return await api.v1.agentInboxMarkAllAsRead(data)
}

export default {
  agentInboxListMessages,
  agentInboxMarkAsRead,
  agentInboxMarkAllAsRead,
}
